import './module.js';
import './directives.js';
import './datetime-picker.js';
import './services.js';
import './ipsPathsControl/edit.controller.js';
import './auditLog/index.controller.js';
import './cacheReset/index.controller.js';
import './sucuriLog/index.controller.js';
import './sites/index.controller.js';
import './sites/blank.controller.js';
import './pentestTasks/index.controller.js';
import './pentestTasks/blank.controller.js';
import './pentestInsights/index.controller.js';